import { z } from 'zod'
import { oc } from '@orpc/contract'

// Internal: called only by the `persona-reconcile-cron` bot (docs/PERSONA_IDV_PLAN.md §10). No
// frontend calls it. Answers with counts only — never patient or inquiry ids — because the bot
// stores the answer in its run's AuditEvent.

export const reconcilePersonaAttempts = oc
  .route({ method: 'POST', path: '/v2/internal/persona/reconcile' })
  .output(
    z.object({
      /** False when Persona is not configured here; nothing was checked. */
      configured: z.boolean(),
      /** Open attempts looked at this run. */
      checked: z.number(),
      updated: z.number(),
      unchanged: z.number(),
      /** Not synced this run (Persona error, write conflict, mismatch); the next run retries. */
      failed: z.number(),
      /** Unfinished past PERSONA_INQUIRY_STALE_MINUTES: patient sent to review (step 6.3). */
      abandoned: z.number(),
      /** Expired at Persona because the patient was verified another way (step 6.3). */
      expired: z.number(),
      /** Pre-visit identity follow-up tasks opened this run (step 6.1). */
      previsitTasks: z.number(),
      /** `pilot_paused` follow-up tasks opened this run, while the pilot flag is off (§11). */
      pausedTasks: z.number(),
    }),
  )
